import React from "react";
import "../styles/home.css";
import SectionTitle from "../components/SectionTitle";

const Home = () => {
  return (
    <div className="home">
      {/* Header Section */}
      <header className="home-header">
        <h1>Empowering the Future through Education & Research</h1>
        <p>Unlocking potential for a better future. We tackle societal challenges with innovative projects.From education to entrepreneurship, we drive change. Building a world of peace, happiness, and purpose.</p>
      </header>

      {/* Video and Text Section (Aligned in One Row) */}
      <section className="video-container">
        {/* Video Element */}
        <div className="video-box">
          <iframe
            className="video-frame"
            src="https://www.youtube.com/embed/iRVtQ1LkblY"
            title="EdGeneOnline Video"
            allowFullScreen
          ></iframe>
        </div>

        {/* Text Section (Aligned Next to Video) */}
        <div className="home-focus">
          <SectionTitle title="Our Key Initiatives" />
          <ul>
            <li>Talent-Based Curriculum for enhanced learning</li>
            <li>Entrepreneurship education for economic growth</li>
            <li>AI governance for responsible technological advancements</li>
            <li>Creating a stress-free environment for all our users</li>
            <li>Connecting our users based on common interest and challenges</li>
          </ul>
        </div>
      </section>

    </div>
  );
};

export default Home;